// extracted by mini-css-extract-plugin
export default {"paper":"giveaway-paper__paper___gEoic"};